<template>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container stitcher-modal flex flex-items--start">
        <button class="ghost-button mar-top--xl mar-right--xl" @click="$emit('cancel')">
            <span class="x-icon x-icon--circle"></span>
          </button>
          <div class="flex-grow--1">
            <div class="modal-header">
              <h1>Confirm Delete</h1>
              <hr>
            </div>
            <div class="modal-body">
                <div class="heading">{{message}}</div>
            </div>
            <div class="modal-footer">
                <button class="ghost-button" @click="$emit('cancel')">Cancel</button>
                <button class="purple-button purple-button--squished" @click="$emit('confirm')">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
export default {
  components: {
  },
  props: {
    message: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
